export default {
  marketPlace: 'Market Place',
  shareTrading: 'Share Trading',
  allMarketActivities: 'All Market Activities',
  allShareActivities: 'All Share Activities',
  imInterested: "I'm interested",
  viewsellinfo: 'View sell info',
  sharesNumber: 'Shares Number',
  pricePerShare: 'Price Per Share',
  totalCost: 'Total Cost',
  sellInformation: 'Sell information',
  shareOwnership: 'Share ownership',
  email: 'Email',
  phoneNumber: 'Phone number',
  equityClass: 'Equity class',
  numberOfShares: 'Number of Shares',
  transactionType: 'Transaction type',
  sell: 'Sell',
  total: 'Total',
  listing: 'Listing',
  highestOfferedPrice: 'Highest Offered Price',
  submit: 'Submit',
  cancel: 'Cancel',
  counterOffer: 'Counter Offer',
  confirm: 'Confirm',
  confirmModalContent:
    'This process can not be cancelled if the seller accept it. If you show interest that means you are fine with the price and the number of shares.',
  areYouSure: 'Are you sure?',
};
